import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatErr } from "@/lib/api";
import { Ladybug } from "@/components/site/Ladybug";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setError("The two passwords do not match yet.");
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, password: pw });
      setDone(data.message);
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="reset-page" className="max-w-xl mx-auto px-6 pt-20">
      <div className="relative card-soft p-8 sm:p-12 bg-white/85">
        <Ladybug spot="tr" size={22} rotate={-40} />
        <span className="eyebrow">Reset your password</span>
        <h1 className="font-serif-h font-light text-4xl text-[#577731] mt-4">Choose a new key to the circle</h1>
        {!token ? (
          <p className="mt-6 text-[#232b1b]/75" data-testid="reset-missing">This reset link is incomplete. Please request a new one from the Ambassador Login.</p>
        ) : done ? (
          <div className="mt-6" data-testid="reset-done">
            <p className="leading-relaxed text-[#232b1b]/80">{done}</p>
            <Link to="/ambassadors?mode=login" className="btn btn-olive mt-8" data-testid="reset-login-btn">Ambassador Login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-5">
            <div><label className="label">New password</label><input required type="password" minLength={6} className="field" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" /></div>
            <div><label className="label">Say it once more</label><input required type="password" minLength={6} className="field" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm-input" /></div>
            {error && <p data-testid="reset-error" className="text-sm text-[#9c3d5c]">{error}</p>}
            <button disabled={busy} className="btn btn-olive w-full" data-testid="reset-submit-btn">{busy ? "One breath…" : "Set My New Password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
